<template>
  <section>
    <div class="wrapper">
      <ul class="bg-bubbles">
        <li
          v-for="n in 10"
          :key="n+'n'"
        ></li>
        <ol
          v-for="m in 5"
          :key="m+'m'"
        ></ol>
      </ul>
      <div
        class="bg bg-blur"
        style="display: none;"
      ></div>
      <div style="height: 10%;"></div>
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-position="left"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h3 class="title">系统登录</h3>
        <el-form-item prop="account">
          <el-input
            type="text"
            v-model="ruleForm2.account"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            v-model="ruleForm2.checkPass"
            auto-complete="off"
            show-password
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <!-- <el-checkbox
        v-model="checked"
        checked
        class="remember"
      >记住密码</el-checkbox> -->

        <!-- <div
        style="margin-bottom: 20px;"
        class="count-test"
      >
        <el-radio-group
          @change="loginAccount"
          v-model="account3"
        >
          <el-radio-button label="测试账号1"></el-radio-button>
          <el-radio-button label="测试账号2"></el-radio-button>
          <el-radio-button label="超级管理员"></el-radio-button>
        </el-radio-group>
      </div> -->

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item style="width:100%;">
              <el-button
                type="primary"
                style="width:100%;"
                @click.native.prevent="handlezc"
              >
                {{loginStr2}}
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="width:100%;">
              <el-button
                type="primary"
                style="width:100%;"
                @click.native.prevent="handleSubmit2"
                :loading="logining"
              >
                {{loginStr}}
              </el-button>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row align="top">
          <el-col
            :span="4"
            :offset="20"
          >
            <el-button
              type="text"
              @click="handlewj"
              style="font-size: 15 px;color: rgb(105, 181, 255);"
            >忘记密码</el-button>
          </el-col>
        </el-row>

        <!-- <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click.native.prevent="handleSubmit2"
          :loading="logining"
        >
          {{loginStr}}
        </el-button>

      </el-form-item> -->

        <!-- <el-form-item style="width:100%;">

        <el-button
          :loading="loginingMock"
          style="width:100%;"
          @click.native.prevent="handleSubmitMock"
        >Mock登录
        </el-button>
      </el-form-item> -->
      </el-form>
    </div>
    <!--注册界面-->
    <el-dialog
      title="注册"
      :visible.sync="zcFormVisible"
      v-model="zcFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="zcForm"
        label-width="80px"
        :rules="zcormRules"
        ref="zcForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="姓名"
              prop="uRealName"
            >
              <el-input
                v-model="zcForm.uRealName"
                auto-complete="off"
                placeholder="显示名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="登录名"
              prop="uLoginName"
            >
              <el-input
                v-model="zcForm.uLoginName"
                auto-complete="off"
                placeholder="登陆代码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="DepID"
              label="部门"
            >
              <el-select
                v-model="zcForm.DepID"
                placeholder="请选择部门"
              >
                <el-option
                  v-for="item in deplist"
                  :key="item.Name"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-radio-group v-model="zcForm.sex">
                <el-radio
                  class="radio"
                  :label="1"
                >男</el-radio>
                <el-radio
                  class="radio"
                  :label="0"
                >女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            label="邮箱"
            prop="mail"
          >
            <el-input
              v-model="zcForm.mail"
              auto-complete="off"
              placeholder="辉源内部邮箱"
              @blur="sendEmail('zcForm')"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-row>
          <el-button @click.native="zcFormVisible = false">取消</el-button>
          <el-button
            type="danger"
            @click.native="register()"
            :loading="submitlogining"
          >提交</el-button>
        </el-row>
      </div>
    </el-dialog>

    <!--忘记密码-->
    <el-dialog
      title="注册"
      :visible.sync="wjFormVisible"
      v-model="wjFormVisible"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form
        :model="wjForm"
        label-width="80px"
        :rules="wjFormRules"
        ref="wjForm"
      >
        <el-row style="margin-bottom: 20px">
          <label>请填写完辉源邮箱后，点击发送验证码按钮，将邮箱内的验证码输入到验证码框，点击重置，重置成功后，临时密钥将发送至对应邮箱，为了确保您的信息安全，请您登录后前往个人中心，修改密码！</label>
        </el-row>
        <el-row :gutter="18">
          <el-col :span="18">
            <el-form-item
              label="邮箱"
              prop="mail"
            >
              <el-input
                v-model="wjForm.mail"
                auto-complete="off"
                placeholder="辉源内部邮箱"
                @blur="sendEmail('wjForm')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click.native.prevent="postvercode"
              :loading="verlogining"
            > 发送验证码 </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="18">
          <el-col :span="18">
            <el-form-item
              label="验证码"
              prop="VerCode"
            >
              <el-input
                v-model="wjForm.VerCode"
                auto-complete="off"
                placeholder="邮箱内验证码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click.native.prevent="postreset"
              :loading="resetlogining"
            > 点击重置密码 </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import { requestLogin, requestLoginMock, getUserByToken, getNavigationBar, getDepListPage, addNewUser, PostVerCode, PostReset } from '../api/api';

import router from '@/router'
import { resetRouter, filterAsyncRouter } from '@/router/index'

export default {
  data() {
    return {
      filters: {
        name: ''
      },
      deplist: [],
      resetlogining: false,
      instance: "",
      huanjing: '',
      submitlogining: false,
      verlogining: false,
      loginStr: '登录',
      loginStr2: '注册',
      logining: false,
      loginingMock: false,
      ruleForm2: {
        account: '',
        checkPass: ''
        //  account: 'blogadmin',
        // checkPass: 'blogadmin'
      },
      account3: '测试账号1',
      rules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          //{ validator: validaePass }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          //{ validator: validaePass2 }
        ]
      },
      checked: true,
      zcormRules: {
        uRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        uLoginName: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
      },
      zcFormVisible: false,
      wjFormVisible: false,
      wjFormRules: {
        VerCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ]
      },
      //注册界面数据
      zcForm: {
        Id: 0,
        uRealName: '',
        uLoginName: '',
      },
      wjForm: {
        mail: ''
      }
    };
  },
  methods: {
    sendEmail: function(type) {

      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (type == 'zcForm') {
        if ((this.zcForm.mail != '' && !regEmail.test(this.zcForm.mail)) || (this.zcForm.mail.split('@')[1] != "utpscm.com" && this.zcForm.mail.split('@')[1] != "wgdairy.com.cn")) {
          this.$message({
            message: '邮箱格式不正确',
            type: 'error'
          })
          this.zcForm.mail = ''
        }
      }
      if (type == 'wjForm') {
        if ((this.wjForm.mail != '' && !regEmail.test(this.wjForm.mail)) || (this.wjForm.mail.split('@')[1] != "utpscm.com" && this.wjForm.mail.split('@')[1] != "wgdairy.com.cn")) {
          this.$message({
            message: '邮箱格式不正确',
            type: 'error'
          })
          this.wjForm.mail = ''
        }
      }

    },
    //显示注册界面
    handlezc: function() {
      this.zcForm = {
        Id: 0,
        uRealName: null,
        uLoginName: '',
        dep: '',
        mail: ''
      };
      this.zcFormVisible = true;
      this.logining = false
    },
    handlewj: function() {
      this.wjFormVisible = true;
      this.logining = false
    },
    //获取部门列表
    getDeps() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getDepListPage(para).then((res) => {
        this.deplist = res.data.response.data;
        this.listLoading = false;
      });
    },
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    loginAccount() {

      if (this.account3 == "测试账号1") {
        // this.ruleForm2.account = "blogadmin";
        // this.ruleForm2.checkPass = "blogadmin";
      } else if (this.account3 == "测试账号2") {
        // this.ruleForm2.account = "test2";
        // this.ruleForm2.checkPass = "test2";
      } else {
        // this.ruleForm2.account = "blogadmin";
        // this.ruleForm2.checkPass = "blogadmin";
      }
    },
    //这个是用来测试 mock 的，很简单，只需要在 main.js 中开启服务即可
    handleSubmitMock(ev) {
      var _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          //_this.$router.replace('/table');
          this.loginingMock = true;
          //NProgress.start();
          var loginParams = { username: this.ruleForm2.account, password: this.ruleForm2.checkPass };

          requestLoginMock(loginParams).then(data => {
            this.loginingMock = false;

            if (data && data.code && data.msg) {
              _this.$message({
                message: data.code + data.msg + "，用户名admin,密码123456",
                type: 'error'
              });
            } else {

              _this.$message({
                message: "测试mock，请在main.js 中开启服务!",
                type: 'error'
              });
              console.info('%c 测试mock，请在main.js 中开启服务!', "color:red")
            }

          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    openAlert(msg) {
      this.instance = this.$notify({
        title: '提示',
        message: msg,
        duration: 0,
        position: 'top-left'
      });
    },
    closeAlert() {
      this.instance.close()
    },
    // 获取 Token
    handleSubmit2(ev) {
      var _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          //_this.$router.replace('/table');
          this.logining = true;

          //NProgress.start();
          var loginParams = { name: this.ruleForm2.account, pass: this.ruleForm2.checkPass };


          // _this.openAlert("登录中...")

          _this.loginStr = "登录中...";

          requestLogin(loginParams).then(data => {
            if (!data.success) {
              _this.$message({
                message: data.msg,
                type: 'error'
              });
              _this.logining = false;
              _this.loginStr = "重新登录";
              // _this.closeAlert()
            } else {

              var token = data.response.token;
              _this.$store.commit("saveToken", token);

              var curTime = new Date();
              var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + data.response.expires_in));
              _this.$store.commit("saveTokenExpire", expiredate);

              window.localStorage.refreshtime = expiredate;
              window.localStorage.expires_in = data.response.expires_in;

              // _this.$notify({
              //   type: "success",
              //   // message: `成功获取令牌，项目初始化中...`,
              //   duration: 3000
              // });


              // _this.closeAlert()
              // _this.openAlert("成功获取Token，等待服务器返回用户信息...")
              // _this.loginStr = "成功获取Token，等待服务器返回用户信息...";

              _this.getUserInfoByToken(token)


            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取用户数据
    getUserInfoByToken(token) {
      var _this = this;
      var loginParams = { token: token };
      getUserByToken(loginParams).then(data => {

        if (!data.success) {
          _this.$message({
            message: data.msg,
            type: 'error'
          });
        } else {
          // _this.closeAlert()
          // _this.openAlert("接收到用户数据，开始初始化路由树...")
          //_this.loginStr = "接收到用户数据，开始初始化路由树...";


          window.localStorage.user = JSON.stringify(data.response)
          if (data.response.uID > 0) {
            _this.GetNavigationBar(data.response.uID)
          }
        }
      });
    },
    // 获取路由树
    GetNavigationBar(uid) {
      var _this = this;
      var loginParams = { uid: uid, t: new Date() };

      getNavigationBar(loginParams).then(data => {
        _this.logining = false;


        if (!data.success) {
          _this.$message({
            message: data.msg,
            type: 'error'
          });
        } else {

          // _this.closeAlert()

          // _this.$message({
          //   message: "后台初始化成功",
          //   type: 'success'
          // });


          let userinfo = JSON.parse(window.localStorage.user ? window.localStorage.user : null);
          // _this.$notify({
          //   type: "success",
          //   message: `登录成功 \n 欢迎 ${userinfo.uRealName} 会话 将在 ${window.localStorage.expires_in / 60} 分钟后过期！`,
          //   duration: 6000
          // });


          window.localStorage.router = (JSON.stringify(data.response.children));

          let getRouter = data.response.children//后台拿到路由
          getRouter = filterAsyncRouter(getRouter) //过滤路由
          router.$addRoutes(getRouter) //动态添加路由

          _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
        }
      });
    },
    //注册
    register: function() {
      this.$refs.zcForm.validate((valid) => {

        if (valid) {
          this.$confirm('确认提交注册信息吗？', '提示', {}).then(() => {

            this.submitlogining = true;
            let para = Object.assign({}, this.zcForm);
            addNewUser(para).then((res) => {

              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['zcForm'].resetFields();
                this.submitlogining = false;
                this.zcFormVisible = false;
              } else {
                this.submitlogining = false;
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    },
    //发送验证码
    postvercode: function() {

      if (this.wjForm.mail.length == 0) {
        this.$message({
          message: "请输入邮箱！",
          type: "error"
        });
        return;
      }



      this.verlogining = true;
      let para = Object.assign({}, this.wjForm);
      PostVerCode(para).then((res) => {

        if (res.data.success) {
          this.verlogining = false;
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
        } else {
          this.verlogining = false;
          this.$message({
            message: res.data.msg,
            type: 'error'
          });

        }
      });
    },
    //重置密码
    postreset: function() {
      this.$refs.wjForm.validate((valid) => {
        if (valid) {
          this.resetlogining = true;
          let para = Object.assign({}, this.wjForm);
          PostReset(para).then((res) => {

            if (res.data.success) {
              this.resetlogining = false;
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.$refs['wjForm'].resetFields();
              this.resetlogining = false;
              this.wjFormVisible = false;
            } else {
              this.resetlogining = true;
              this.$message({
                message: res.data.msg,
                type: 'error'
              });

            }
          });
        }
      });
    },
  },
  mounted() {
    // window.localStorage.clear()
    this.getDeps();
    console.info('%c 本地缓存已清空!', "color:green")

    this.huanjing = process.env.NODE_ENV;
    console.info(this.huanjing, "color:green")
    //development
    //production
    if (this.huanjing == 'production') {
      this.ruleForm2 = {
        account: '',
        checkPass: ''
      }
    }
    else {
      this.ruleForm2 = {
        account: 'blogadmin',
        checkPass: 'blogadmin'
      }
    }
    // var tmp = this.huanjing == 'production' ? {
    //   account: '',
    //   checkPass: ''
    // } : {
    //   account: 'blogadmin',
    //   checkPass: 'blogadmin'
    // };
    // this.ruleForm2 = tmp;
    console.info(this.ruleForm2, "color:green")
    // ruleForm2: {
    //   account: '',
    //     checkPass: ''
    //   //  account: 'blogadmin',
    //   // checkPass: 'blogadmin'
    // },

  },
}

</script>

<style>
.bg {
  margin: 0px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: url(../assets/loginbck.png) no-repeat top left;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  z-index: 9999;
  position: relative;
}

.login-container .title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.login-container .remember {
  margin: 0px 0px 25px 0px;
}

.wrapper {
  background: #50a3a2;
  background: -webkit-linear-gradient(top left, #50a3a2 0%, #53e3a6 100%);
  background: linear-gradient(to bottom right, #127c7b 0, #50a3a2);
  opacity: 0.8;
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.wrapper.form-success .containerLogin h1 {
  -webkit-transform: translateY(85px);
  -ms-transform: translateY(85px);
  transform: translateY(85px);
}

.containerLogin {
  max-width: 600px;
  margin: 0 auto;
  padding: 80px 0;
  height: 400px;
  text-align: center;
}

.containerLogin h1 {
  font-size: 40px;
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
  -webkit-transition-timing-function: ease-in-put;
  transition-timing-function: ease-in-put;
  font-weight: 200;
}

.bg-bubbles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.bg-bubbles li,
.bg-bubbles ol {
  position: absolute;
  list-style: none;
  display: block;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.15);
  bottom: -160px;
  -webkit-animation: square 25s infinite;
  animation: square 25s infinite;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
}

ol {
  padding: 0 !important;
}

.bg-bubbles ol:nth-child(11) {
  left: 10%;
  top: 10%;
  width: 20px;
  height: 20px;
}

.bg-bubbles ol:nth-child(12) {
  left: 20%;
  top: 40%;

  width: 60px;
  height: 60px;
}

.bg-bubbles ol:nth-child(13) {
  left: 65%;
  top: 30%;

  width: 100px;
  height: 60px;
}

.bg-bubbles ol:nth-child(14) {
  left: 70%;
  top: 30%;
  width: 100px;
  height: 150px;
}

.bg-bubbles ol:nth-child(15) {
  left: 50%;
  top: 70%;

  width: 40px;
  height: 60px;
}

.bg-bubbles li:nth-child(1) {
  left: 10%;
}

.bg-bubbles li:nth-child(2) {
  left: 20%;
  width: 80px;
  height: 80px;
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
  -webkit-animation-duration: 17s;
  animation-duration: 17s;
}

.bg-bubbles li:nth-child(3) {
  left: 25%;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
}

.bg-bubbles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  -webkit-animation-duration: 22s;
  animation-duration: 22s;
  background-color: rgba(255, 255, 255, 0.25);
}

.bg-bubbles li:nth-child(5) {
  left: 70%;
}

.bg-bubbles li:nth-child(6) {
  left: 80%;
  width: 120px;
  height: 120px;
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
  background-color: rgba(255, 255, 255, 0.2);
}

.bg-bubbles li:nth-child(7) {
  left: 32%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 7s;
  animation-delay: 7s;
}

.bg-bubbles li:nth-child(8) {
  left: 55%;
  width: 20px;
  height: 20px;
  -webkit-animation-delay: 15s;
  animation-delay: 15s;
  -webkit-animation-duration: 40s;
  animation-duration: 40s;
}

.bg-bubbles li:nth-child(9) {
  left: 25%;
  width: 10px;
  height: 10px;
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
  -webkit-animation-duration: 40s;
  animation-duration: 40s;
  background-color: rgba(255, 255, 255, 0.3);
}

.bg-bubbles li:nth-child(10) {
  left: 90%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 11s;
  animation-delay: 11s;
}

@-webkit-keyframes square {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
    transform: translateY(-700px) rotate(600deg);
  }
}

@keyframes square {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }

  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
    transform: translateY(-700px) rotate(600deg);
  }
}
</style>
